export function freshMachineSignal(running: boolean | null | undefined, measuredAt: string | null | undefined, now = Date.now()) {
  const time = Date.parse(measuredAt ?? "");
  return typeof running === "boolean" && Number.isFinite(time) && Math.abs(now - time) <= 10_000 ? running : null;
}
